




import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    PatientProfileForm: () =>
      import('@/components/patient/profileForm/PatientProfileForm.vue')
  }
})
export default class PatientProfileEdit extends Vue {
  $store!: ExStore

  get patientInfo() {
    return this.editingInputs || this.$store.getters['user/patientInfo']
  }

  get editingInputs() {
    return this.$store.getters['user/sessionData']('patientPatchPayload')
  }

  async created() {
    if (!this.editingInputs) {
      await this.$store.dispatch('user/updatePatientInfo')
    }
  }
}
